import { useTranslation } from "react-i18next";
import { clearAlerts, setListMessage, setErrorAlert } from './../../../config/redux/alerts/alertsActions';
import { useDispatch, RootStateOrAny, useSelector } from "react-redux";
import i18next from "i18next";
import { splitStoredPhone, defaultPrefix as getDefaultPrefix, ADMIN_PHONE_PREFIXES } from "../../common/layout/form/PhonePrefixField";
import { FormikValues } from "formik";

import {
  setAdmin,
  addNewAdmin,
  toggleAdminsPanel,
} from "../../../config/redux/admins/adminsActions";
import { addAdmin, editAdmin} from "../../../connectors/admins/connectors/index";
import {IAdmin} from "../../../connectors/admins/models/index"
import { IResetForm } from "../../common/models/resetForm.type";
import { useState } from "react";

export const useAdminForm = () => {
  const [loading, setIsLoading] = useState(false)
  const { selectedAdmins, activeAdmin } = useSelector(
    (state: RootStateOrAny) => state.admins
  );
  const [editedAdmin] = useState(() => selectedAdmins[0]);
  const dispatch = useDispatch();
  const { t } = useTranslation("admin");
  const defaultPrefix = getDefaultPrefix(i18next.language, ADMIN_PHONE_PREFIXES);
  const existingPhoneSplit = editedAdmin
    ? splitStoredPhone(editedAdmin.phone || "", i18next.language, ADMIN_PHONE_PREFIXES)
    : null;

  let initValues = {
    firstName: "",
    lastName: "",
    phonePrefix: defaultPrefix,
    phone: "",
    phoneNumber: "",
    email: "",
  };

  if (editedAdmin) {
    initValues = {
      firstName: editedAdmin.firstName,
      lastName: editedAdmin.lastName,
      phonePrefix: existingPhoneSplit!.prefix,
      phone: existingPhoneSplit!.number,
      email: editedAdmin.email,
      phoneNumber: editedAdmin.phone,
    };
  }

  const add = async (data: IAdmin) => {
    const res = await addAdmin(data);
  };

  const edit = async (data: IAdmin) => {
    data.phoneNumber = data.phone;
    await editAdmin(data, editedAdmin.id);
  };

  const handleSubmit = async (
    values: FormikValues,
    { resetForm }: IResetForm
  ) => {
    setIsLoading(true)
    const fullPhone = values.phone ? (values.phonePrefix || "") + values.phone : "";
    const body = {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      phone: fullPhone,
      phoneNumber: fullPhone,
    };
    try {
      dispatch(clearAlerts())
      editedAdmin ? await edit(body) : await add(body);
      setIsLoading(false)
      dispatch(setAdmin({}));
      dispatch(addNewAdmin({ add: true }));
      resetForm();
      dispatch(toggleAdminsPanel({ open: false }));
      dispatch(setListMessage(t("nav.operationSuccess") as string))
    } catch (err) {
      setIsLoading(false)
      dispatch(setErrorAlert(t("nav.operationError") as string))
    }
  };

  const cancelForm = () => {
    dispatch(toggleAdminsPanel({ open: false }));
    dispatch(clearAlerts())
  };

  return {
    handleSubmit,
    initValues,
    cancelForm,
    editedAdmin,
    loading
  };
};
